import { defineStore } from 'pinia';
import api from './../api/api.ts';
import { useNotification } from "@kyvg/vue3-notification";

const { notify } = useNotification();

interface HomeWorksSettings {
    mode: string;
    speed: number;
    frequency: number;
    height: number;
    offset: number;
    LETTER_REPLACEMENTS: any[];
    isTimerDisabled: boolean;
}

export interface ApiHomework {
    id: number;
    trainerId: number;
    deadline: string;
    startDate: string;
    homeWorksSettings: HomeWorksSettings;
    status: 'pending' | 'in-progress' | 'completed' | 'overdue' | 'done';
    statusDate: string;
    createDate: string;
}

export const useHomeworksStore = defineStore('homeworks', {
    state: () => ({
        homeworks: [] as ApiHomework[],
        loading: false,
        error: null as string | null,
        activeHomeworkId: null as number | null,
    }),

    actions: {
        setActiveHomework(homeworkId: number | null) {
            this.activeHomeworkId = homeworkId;
        },

        async fetchHomeworks() {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.get<ApiHomework[]>('/student/homeworks');
                this.homeworks = response.data;
            } catch (error: any) {
                const errorMessage = error.response?.data?.message || 'homework.notifications.fetch_error';
                this.error = errorMessage;
                notify({ title: errorMessage, type: "error" });
            } finally {
                this.loading = false;
            }
        },

        async markHomeworkAsDone(homeworkId: number) {
            console.log("req for done homework");
            try {
                await api.post('/student/homeworks/mark-done', { homework_id: homeworkId });
                notify({
                    title: "homework.notifications.mark_done_success",
                    type: "success"
                });
                await this.fetchHomeworks();
            } catch (error: any) {
                const errorMessage = error.response?.data?.message || "homework.notifications.mark_done_error";
                notify({ title: errorMessage, type: "error" });
                throw error;
            }
        },

        async claimReward(homeworkId: number) {
            try {
                await api.post('/student/homeworks/claim', { homework_id: homeworkId });
                const index = this.homeworks.findIndex(hw => hw.id === homeworkId);
                if (index !== -1) {
                    this.homeworks.splice(index, 1);
                }
                notify({
                    title: "homework.notifications.claim_reward_success",
                    type: "success"
                });
            } catch (error: any) {
                const errorMessage = error.response?.data?.message || "homework.notifications.claim_reward_error";
                notify({ title: errorMessage, type: "error" });
                throw error;
            }
        },
    },

    getters: {
        isLoading: (state) => state.loading,
        getHomeworks: (state) => state.homeworks,
        getActiveHomeworkId: (state) => state.activeHomeworkId,
    },
});